
/* ==========================================================================

  Test view for lalisation and translation testing.

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Decription: THIS FILE IS NOT MEANT FOR PRODUCTION AND WILL BE EXCLUDED WITH GRUNT DIST TASK
              Details of how this works can be found here: http://localhost:3000/dev-views/handlebars-translations.html
========================================================================== */

'use strict';

//Require Modules
var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  LocalisationTestsModel = require('./localisationTestsModel'),
  tmpl = require('../../tmpl/fe-tests/localisation.hbs');

Backbone.$ = $;

var LocalisationTests =  Backbone.View.extend({
  template: tmpl,
  initialize: function() {
    this.model = new LocalisationTestsModel();
    this.listenTo(this.model, 'sync', _.bind(this.render, this));

    this.model.fetch();

  },
  render: function() {
    this.$el.html(this.template(this.model.toJSON()));
  }
});

module.exports = LocalisationTests;



// WEBPACK FOOTER //
// ./assets/js/frontend-only/localisationTests.js